import React from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import useModal from '../../utils/hooks/useModal'
import Modal from '../../components/modal/Modal'
import CompaniesService from '../../services/companies/companies.service'
import CompanyForm from '../../components/company/CompanyForm'
import useAccess from '../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../utils/constants/roles'
import { DataTableFun } from '../../utils/helpers/dataTableFun'
import useInputs from '../../utils/hooks/useInputs'
import useHandlerBasicActions from '../../utils/hooks/useHandlerBasicActions'
import EditButton from '../../components/common/buttons/EditButton'
import DataTableComp from '../../components/common/data-table/DataTableComp'
import MainCommonView from '../../components/common/MainCommonView'

const Companies = () => {
  const { formatMessage: msg } = useIntl()

  const { isShowing, toggle } = useModal()
  const { isShowing: isShowingEdit, toggle: toggleEdit } = useModal()
  const { canAdd, canDelete, canEdit } = useAccess()
  const { inputs, updateInputs } = useInputs()

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'name',
    getAll: CompaniesService.getAll,
    removeAction: CompaniesService.remove,
    editAction: CompaniesService.update,
    createAction: CompaniesService.create,
  })

  const handleCreate = async (data) => {
    const resp = await dataFacade.create(data)
    if (resp) {
      toggleModal({})
    }
  }

  const handleUpdateMutual = async (data) => {
    const resp = await dataFacade.edit({ _id: data?._id, body: data })
    if (resp) {
      toggleEditModal({})
    }
  }

  const toggleEditModal = (data) => {
    updateInputs(data)
    toggleEdit()
  }

  const toggleModal = () => {
    updateInputs({})
    toggle()
  }

  const buttonEdit = (rowData) => (
    <EditButton onClick={() => toggleEditModal(rowData)} />
  )
  const headerOptions = {
    title: msg({ id: 'companies' }),
    handlerHeaderActions: {
      showBackButton: true,
      secondaryButton: canAdd(MODULES.SETTINGS, GROUPS.MUTUAL) && toggleModal,
      secondaryButtonText: 'button.add',
      secondaryButtonIcon: 'pi-plus',
    },
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      tableOptions={{
        className: 'table-without-menu',
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column field="name" header={msg({ id: 'name' })} sortable />,
        <Column field="mutual.name" header={msg({ id: 'mutual' })} />,
        <Column field="sageCode" header={msg({ id: 'sageCode' })} />,
        <Column field="nif" header={msg({ id: 'NIF' })} />,
        <Column field="account1" header={msg({ id: 'account1' })} />,
        <Column field="account2" header={msg({ id: 'account2' })} />,
        canDelete(MODULES.SETTINGS, GROUPS.COMPANIES) && (
          <Column
            body={(rowData) =>
              DataTableFun.buttonDelete(rowData, dataFacade.remove)
            }
            exportable={false}
          />
        ),
        canEdit(MODULES.SETTINGS, GROUPS.COMPANIES) && (
          <Column body={buttonEdit} exportable={false} />
        ),
      ]}
    />
  )

  return (
    <div className="companies-container">
      <MainCommonView
        headerOptions={headerOptions}
        componentData={dataTable}
        pagerOptions={pagerOptions}
      />

      <Modal
        isShowing={isShowing}
        hide={() => toggleModal({})}
        width="90%"
        maxWidth="650px"
        title={msg({ id: 'company.add' })}
        context={<CompanyForm submit={handleCreate} />}
      />

      <Modal
        isShowing={isShowingEdit}
        hide={() => toggleEditModal({})}
        width="90%"
        maxWidth="650px"
        title={msg({ id: 'company.edit' })}
        context={
          <CompanyForm companyId={inputs?._id} submit={handleUpdateMutual} />
        }
      />
    </div>
  )
}

export default Companies
